/* eslint-disable max-len, padded-blocks, prefer-destructuring */

export default {
  data() {
    return {
      sortBy: 'lineItemProductName',
      sortDesc: false,
      projectWorkOrderBillLineItemFields: [
        {
          key: 'lineItemProductName',
          label: 'Service/Material',
          thClass: 'workorder-table-header',
          sortable: true,
        },
        {
          key: 'salePrice',
          label: 'Unit Cost',
          formatter: (value) => this.$options.filters.toCurrency(value),
          thClass: 'workorder-table-header',
          class: 'text-right currency-column',
        },
        {
          key: 'quantity',
          label: 'Qty Billed',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header',
          class: 'text-right number-column',
        },
        {
          key: 'itemCost',
          label: 'Item Cost',
          formatter: (value) => this.$options.filters.toCurrency(value),
          thClass: 'workorder-table-header ',
          class: 'text-right currency-column',
        },
        {
          key: 'fundingSourceId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const fundingSource = this.fundingSources.find((e) => e.recorD_ID === value);
              if (fundingSource) {
                return fundingSource.recorD_NAME;
              }
            }
            return 'N/A';
          },
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: true,
        },
      ],
      projectWorkOrderBillIncentivePaymentFields: [
        {
          key: 'incentiveType',
          label: 'Incentive Type',
          thClass: 'workorder-table-header',
          sortable: true,
        },
        {
          key: 'amountBilled',
          label: 'Amount Billed',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'fundingSourceId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const fundingSource = this.fundingSources.find((e) => e.recorD_ID === value);
              if (fundingSource) {
                return fundingSource.recorD_NAME;
              }
            }
            return 'N/A';
          },
          thClass: 'workorder-table-header',
          sortable: true,
          sortByFormatted: true,
        },
      ],
      projectWorkOrderBillLineItemFieldsAdd: [
        {
          key: 'lineItemProductName',
          label: 'Service/Material',
          thClass: 'workorder-table-header',
          class: 'align-middle',
          sortable: true,
        },
        {
          key: 'salePrice',
          label: 'Unit Cost',
          thClass: 'workorder-table-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'lineItemQuantity',
          label: 'Original Qty',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'lineItemQuantityBilledToDate',
          label: 'Qty Bill-to-Date',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'quantity',
          label: 'Qty Billed',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header project-workorder-bills-items-required-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'lineItemProductUnit',
          label: 'Units',
          formatter: (value) => {
            if (value) {
              return value;
            }
            return '';
          },
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
        {
          key: 'itemCost',
          label: 'Item Cost',
          thClass: 'workorder-table-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'fundingSourceId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const fundingSource = this.fundingSources.find((e) => e.recorD_ID === value);
              if (fundingSource) {
                return fundingSource.recorD_NAME;
              }
            }
            return 'N/A';
          },
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
      ],
      projectWorkOrderBillIncentivePaymentFieldsAdd: [
        {
          key: 'billSelected',
          label: 'Select',
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
        {
          key: 'incentiveType',
          label: 'Incentive Type',
          thClass: 'workorder-table-header',
          class: 'align-middle',
          sortable: true,
        },
        {
          key: 'paymentAmount',
          label: 'Payment Amount',
          thClass: 'workorder-table-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'amountBilled',
          label: 'Amount Billed',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header project-workorder-bills-items-required-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'fundingSourceId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const fundingSource = this.fundingSources.find((e) => e.recorD_ID === value);
              if (fundingSource) {
                return fundingSource.recorD_NAME;
              }
            }
            return 'N/A';
          },
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
      ],
      projectWorkOrderBillLineItemFieldsEdit: [
        {
          key: 'lineItemProductName',
          label: 'Service/Material',
          thClass: 'workorder-table-header',
          class: 'align-middle',
          sortable: true,
        },
        {
          key: 'salePrice',
          label: 'Unit Cost',
          thClass: 'workorder-table-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'lineItemQuantity',
          label: 'Original Qty',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'lineItemQuantityBilledToDate',
          label: 'Qty Bill-to-Date',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'quantity',
          label: 'Qty Billed',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header project-workorder-bills-items-required-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'lineItemProductUnit',
          label: 'Units',
          formatter: (value) => {
            if (value) {
              return value;
            }
            return '';
          },
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
        {
          key: 'itemCost',
          label: 'Item Cost',
          thClass: 'workorder-table-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'fundingSourceId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const fundingSource = this.fundingSources.find((e) => e.recorD_ID === value);
              if (fundingSource) {
                return fundingSource.recorD_NAME;
              }
            }
            return 'N/A';
          },
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
      ],
      projectWorkOrderBillIncentivePaymentFieldsEdit: [
        {
          key: 'billSelected',
          label: 'Selected',
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
        {
          key: 'incentiveType',
          label: 'Incentive Type',
          thClass: 'workorder-table-header',
          class: 'align-middle',
          sortable: true,
        },
        {
          key: 'paymentAmount',
          label: 'Payment Amount',
          thClass: 'workorder-table-header',
          class: 'align-middle text-right currency-column',
        },
        {
          key: 'amountBilled',
          label: 'Amount Billed',
          thClass: 'workorder-table-header project-workorder-bills-items-quantity-header project-workorder-bills-items-required-header',
          class: 'align-middle text-right number-column',
        },
        {
          key: 'fundingSourceId',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              const fundingSource = this.fundingSources.find((e) => e.recorD_ID === value);
              if (fundingSource) {
                return fundingSource.recorD_NAME;
              }
            }
            return 'N/A';
          },
          thClass: 'workorder-table-header',
          class: 'align-middle',
        },
      ],
    };
  },
};
